import React, { useState, useEffect } from 'react';
import '../../App.css';
import {
  Grid,
  Box,
  Button,
  Paper,
  Stack,
  Typography
} from '@mui/material';
import { Add, PriceChange, Edit } from '@mui/icons-material';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Notification from '../Notification';
import Popup from '../Popup';
import Progress from '../Progress';
import AddEarningDeductionForm from './AddEarningDeductionForm';

function EarningDeductionForm() {
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: '' });
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [editData, setEditData] = useState(null);
  const navigate = useNavigate();

  const handleCloseModal = () => {
    setOpenPopup(false);
    setEditData(null); // Clear edit data when closing
  };

  const handleEdit = (row) => {
    setEditData(row);
    setOpenPopup(true);
  };

  const handleAdd = () => {
    setEditData(null);
    setOpenPopup(true);
  };

  const fetchTableData = () => {
    setLoading(true);
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/company-master/get-auto-earning-deduction`)
      .then(function (response) {
        if (response.status === 200 && response.data.status && response.data.data) {
          setTableData(response.data.data);
        }
        setLoading(false);
      })
      .catch(function (error) {
        setLoading(false);
        if (error.response) {
          if (error.response.status === 401) {
            setNotify({
              isOpen: true,
              message: 'Session Expired!',
              type: 'error'
            });
            setTimeout(() => {
              navigate('/');
            }, 1000);
          } else {
            setNotify({
              isOpen: true,
              message: error.response.data?.error_message || 'Error fetching data',
              type: 'error'
            });
          }
        } else {
          setNotify({
            isOpen: true,
            message: 'Network error. Please try again.',
            type: 'error'
          });
        }
      });
  };

  useEffect(() => {
    fetchTableData();
  }, []);


  return (
    <Box sx={{ display: "flex", justifyContent: "center", margin: "10px", padding: "50px", fontWeight: "500px" }}>
      <Paper elevation={5} sx={{ width: "800px" }}>
        <Grid className="form-title" style={{ marginBottom: "-60px" }} container spacing={2}>
          <Grid item>
            <Typography variant="h5" sx={{ textAlign: "center", margin: 5 }}>
              Earning/Deduction
            </Typography>
          </Grid>
          <Grid item>
            <PriceChange style={{ marginLeft: "-30px" }} sx={{ width: 45, height: 45 }} />
          </Grid>
        </Grid>
        <form autoComplete="off" onSubmit={(e) => e.preventDefault()}>
          <Stack spacing={2} sx={{ margin: "33px" }}>

            <Stack display="flex" sx={{ alignItems: "flex-end", marginRight: "30px" }}>
              <Button
                style={{ width: "200px" }}
                className="form-btn"
                variant="outlined"
                color="success"
                onClick={handleAdd}
                startIcon={<Add sx={{ width: "24px", height: "24px" }} />}
                sx={{
                  whiteSpace: "nowrap",
                  textTransform: "none"
                }}
              >
                Add Earning/Deduction
              </Button>
            </Stack>

            {/* Table to display fetched data */}
            {loading ? <Progress /> : (
              tableData.length > 0 ? (
                <div>
                  <table style={{ marginLeft: "30px" }} className="table">
                    <thead className="table-dark">
                      <tr>
                        <th scope="col">Type of Event</th>
                        <th scope="col">Type</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Effective Date</th>
                        <th scope="col">Active</th>
                        <th className="table-dark"></th>
                      </tr>
                    </thead>
                    <tbody>
                      {tableData.map((row) => (
                        <tr key={row.ed_id}>
                          <td>{row.ed_type}</td>
                          <td>
                            {row.auto_earning === 1 ? 'Auto Earning' : row.auto_deduction === 1 ? 'Auto Deduction' : '-'}
                          </td>
                          <td>
                            ₹{parseFloat(row.amount || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                          </td>
                          <td>
                            {row.effective_from_date ? new Date(row.effective_from_date).toLocaleDateString('en-GB') : '-'}
                          </td>
                          <td>
                            {row.status === 1 ? 'Yes' : 'No'}
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-outline-primary btn-sm"
                              onClick={() => handleEdit(row)}
                            >
                              <Edit /> Edit
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <Typography sx={{ textAlign: "center", padding: "20px", color: "text.secondary" }}>
                  No data available
                </Typography>
              )
            )}

          </Stack>
        </form>

        <Popup
          title={editData ? "Edit Earning/Deduction" : "Add Earning/Deduction"}
          openPopup={openPopup}
          setOpenPopup={setOpenPopup}
        >
          <AddEarningDeductionForm 
            setOpenPopup={setOpenPopup} 
            fetchTableData={fetchTableData}
            onCloseModal={handleCloseModal}
            editData={editData}
          />
        </Popup>

      </Paper>
      <Notification notify={notify} setNotify={setNotify} />
    </Box>
  );
}

export default EarningDeductionForm;

